import React from 'react';
import { Spinner } from './Spinner';

export function PageSpinner() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      background: 'var(--khv-bg)',
    }}>
      <Spinner size={28} />
    </div>
  );
}
